"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttemptRubricSelectionSerializer = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const attempt_serializer_1 = require("./attempt.serializer");
class AttemptRubricSelectionSerializer extends dp_http_client_lib_1.PageableSerializer {
    constructor(attemptSerializer = new attempt_serializer_1.AttemptSerializer()) {
        super();
        this.attemptSerializer = attemptSerializer;
    }
    serializeOne(data) {
        return {
            id: data.id,
            attempt: data.attempt ? this.attemptSerializer.serializeOne(data.attempt) : undefined,
            responses: this.serializeRubricSelections(data.responses),
        };
    }
    serializeRubricSelections(data) {
        if (Array.isArray(data)) {
            return data.map((d) => this.serializeOneRubricSelections(d));
        }
        return [];
    }
    serializeOneRubricSelections(data) {
        return {
            externalQuestionId: data.externalQuestionId,
            criteriaSelections: this.serializeRubricOptions(data.criteriaSelections),
            answerDoesNotApply: data.answerDoesNotApply,
        };
    }
    serializeRubricOptions(data) {
        if (Array.isArray(data)) {
            return data.map((d) => this.serializeOneRubricOptions(d));
        }
        return [];
    }
    serializeOneRubricOptions(data) {
        return {
            categoryId: data.categoryId,
            criterionId: data.criterionId,
            ratingId: data.ratingId,
        };
    }
}
exports.AttemptRubricSelectionSerializer = AttemptRubricSelectionSerializer;
//# sourceMappingURL=attempt-rubric-selection.serializer.js.map